import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { SuggestedPromptsItemInterface } from './interfaces/suggested-prompts-item.interface';
import { TOOLTIP_POSITION } from '../../constants/tooltip-position.constant';

@Component({
    selector: 'mapp-suggested-prompts',
    templateUrl: './suggested-prompts.component.html',
    styleUrls: ['./suggested-prompts.component.scss'],
    standalone: false,
})
export default class SuggestedPromptsComponent implements OnChanges {
    @Input() prompts: SuggestedPromptsItemInterface[] = [];

    @Output() selected: EventEmitter<string> = new EventEmitter();

    tooltipPosition = TOOLTIP_POSITION;

    randomPrompts: SuggestedPromptsItemInterface[] = [];

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['prompts']) {
            this.refreshPrompts();
        }
    }

    /**
     *
     */
    refreshPrompts() {
        this.randomPrompts = this.getRandomPrompts();
    }

    /**
     *
     * @param text
     */
    handlePromptSelected(text: string) {
        this.selected.emit(text);
    }

    /**
     *
     */
    private getRandomPrompts(): SuggestedPromptsItemInterface[] {
        return [...this.prompts].sort(this.sortFunction).slice(0, 4);
    }

    /**
     *
     */

    /**
     *
     */
    private sortFunction(): number {
        const crypto = window.crypto || (window as any).msCrypto;
        const array = new Uint32Array(1);
        const randomNumber = crypto.getRandomValues(array)[0] / 10000000000;

        return 0.2 - randomNumber;
    }
}
